import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

import { ReducerCreators } from "@reduxjs/toolkit";

export const typedReducerCreator = <T>(create: ReducerCreators<T>) => {
  const createWithType = create.asyncThunk.withTypes<{
    extra: { client: ApolloClient<NormalizedCacheObject> };
  }>();

  return { create, createWithType };
};
